import { useEffect } from 'react';

export const useKeydown = (effect: (event: KeyboardEvent) => void) => {
  useEffect(() => {
    document.addEventListener('keydown', effect);
    return () => document.removeEventListener('keydown', effect);
  }, [effect]);
};
